import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import './index.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#800020', // Deep maroon
      light: '#a0002a',
      dark: '#600018',
    },
    secondary: {
      main: '#2c2c2c', // Charcoal black
      light: '#404040',
      dark: '#1a1a1a',
    },
    background: {
      default: '#faf9f7', // Warm off-white
      paper: '#ffffff',
    },
    text: {
      primary: '#2c2c2c', // Dark charcoal for main text
      secondary: '#666666', // Medium gray for secondary text
    },
  },
  typography: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8,
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <App />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
